<template>

<div class="nadlan-menu">
    <nav class="container-fluid">
        <div v-for="(tab, index) in tabs" :key="index" :class="isActive(tab.page)">
            <router-link
                :to="mixin_computeTargetPath()[tab.key]"
            >
                {{ tab.label }}
            </router-link>
        </div>
    </nav>
</div>

</template>
<script>

export default {
    name: "HeaderTabs",
    data() {
        return {
            tabs: [
                { page: "deals", key: "buy", label: "עסקאות מכירה" },
                { page: "rent", key: "rent", label: "שכירות" },
                { page: "info", key: "info", label: "מה בסביבה" },
            ],  
        };
    },
    methods: {
        isActive(page) {
            //get router query.page
            if (this.$route.query.page === page) {
                return "active";
            }
            return "";
        },

    },
};

</script>